import { ZoneDimensions, ZoneWithCells } from "../../../types";
import { snapCells } from "./snapCells";
import { Cell, CELL_THRESHOLD, State } from "./types";

const mapCells = (zone: ZoneWithCells): Array<Cell> => {
  if (!zone.cells || zone.cells.length < 1) {
    return [
      {
        maxX: zone.maxX - zone.minX,
        maxY: zone.maxY - zone.minY,
        minX: 0,
        minY: 0,
        selectedBorder: null,
        selected: false,
        cellType:"Cell",
        bottomBorderImplicit:false,
        leftBorderImplicit: false,
        rightBorderImplicit: false,
        topBorderImplicit: false
      },
    ];
  }
  // find the extremes of the cells
  const minX = Math.min(...zone.cells.map(c => c.minX));
  const minY = Math.min(...zone.cells.map(c => c.minY));
  const maxX = Math.max(...zone.cells.map(c => c.maxX));
  const maxY = Math.max(...zone.cells.map(c => c.maxY));
  const zoneWidth = zone.maxX - zone.minX;
  const zoneHeight = zone.maxY - zone.minY;
  // map the cells to table-relative positions and extend their edges to the extremes
  return zone.cells.map(
    (c: ZoneDimensions): Cell => {
      const zoneDimensions = {
        maxX: Math.min(c.maxX === maxX ? zoneWidth : c.maxX - zone.minX, zoneWidth),
        maxY: Math.min(c.maxY === maxY ? zoneHeight : c.maxY - zone.minY, zoneHeight),
        minX: Math.max(c.minX === minX ? 0 : c.minX - zone.minX, 0),
        minY: Math.max(c.minY === minY ? 0 : c.minY - zone.minY, 0),
      };
      return {
        ...zoneDimensions,
        selected: false,
        selectedBorder: null,
        cellType: c.cellType,
        bottomBorderImplicit: c.bottomBorderImplicit,
        topBorderImplicit: c.topBorderImplicit,
        leftBorderImplicit: c.leftBorderImplicit,
        rightBorderImplicit: c.rightBorderImplicit,
      };
    },
  );
};

export const getDefaultState = (zone: ZoneWithCells): State => {
  const zoneWidth = zone.maxX - zone.minX;
  const zoneHeight = zone.maxY - zone.minY;
  const cells = snapCells(mapCells(zone), zoneWidth, zoneHeight, CELL_THRESHOLD);
  if (cells.length > 0) {
    cells[0] = {
      ...cells[0],
      selected: true
    }
  }
  return {
    cellHistory: [cells],
    cellHistoryIndex: 0,
    cells,
    dragOffset: {
      maxX: 0,
      maxY: 0,
      minX: 0,
      minY: 0,
      x: 0,
      y: 0,
    },
    mouseDragStart: null,
    mousePosition: null,
    showTableUI: true,
    withinGutter: null,
    zoneHeight,
    zoneWidth,
    selectedCellTypeGroup: null
  };
};
